import ReactDOM from "react-dom/client";
import "./index.less";
import App from "./App";
import { ConfigProvider, Spin } from "antd";
import reportWebVitals from "./reportWebVitals";
import { store } from "./Store";
import { Desktop } from "./Desktop";
import { LoadingOutlined, setTwoToneColor } from "@ant-design/icons";
import { Message } from "./message";
import { Notification } from "./notification";
import "./behavior"; 

Spin.setDefaultIndicator(
  <LoadingOutlined style={{ fontSize: 24 }}></LoadingOutlined>
);

const win = global as any;
const root = ReactDOM.createRoot(
  win.document.getElementById("root") as HTMLElement
);

setTwoToneColor("#1677ff");

console.log(
  `
 _____ __ __ _____ _____ _____ _____ _____ _____ _____ 
|   __|  |  |  _  |     |  _  |  _  |  _  |   __| __  |
|   __|-   -|     | | | |   __|     |   __|   __|    -|
|_____|__|__|__|__|_|_|_|__|  |__|__|__|  |_____|__|__|
`
);

store.init().then(() => {
  root.render(
    // <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1677ff",
        },
      }}
    > 
      <App />
      <Message></Message>
      <Notification></Notification>
      <Desktop></Desktop>
    </ConfigProvider>
    // </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
